<template>

    <li>
      <a data-toggle="tab" :href="'#episode' + epIndexTab" :data-id="epIndexTab">Episode {{ epIndexTab }}</a><span class="label" @click.prevent="removeEpTab"> x </span>
    </li>

</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
export default {
  props: ["epIndexTab"],
  name: 'EpTabAdd',
  data () {
    return {
    	
    }
  },
  computed: {
   
  },
  methods:{
    removeEpTab() {
      this.$emit('removeEpTab')
    }
   }
  //
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/child/EpTabAdd.vue